<script lang="ts">
	import { SelectCard, CardGrid, Toggle } from '@Shelly/shelly-design-system';
	import { createEventDispatcher, onMount } from 'svelte';
	import { capFirstChar, _calculate_duration } from '../../../../../../../../../helpers/utilities';
	import { format } from '../../../../../../../../../services/i18n';
	import TrvControlWithWheelV2 from './TRVControlWithWheelV2.svelte';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let actions = [], //available actions for the device
		active_actions = [], // active action must be the one of provided options
		sceneIsValid,
		deviceId: string; //deviceId is needed to get the device status from where we can receive the target temperature of the Wall Display's thermostat

	const dispatch = createEventDispatcher();

	const mappedIcons = {
		0: 'fas fa-power-off text-success',
		1: 'fas fa-power-off text-danger',
		2: 'fas fa-thermometer-half',
	}; //need this as a workaround for the icons in the select card
	const realDeviceId = deviceId.split('_')[0];
	$: statusStore = getDeviceStatus(real_id(realDeviceId));
	$: deviceStatus = $statusStore;

	let enabled = active_actions?.[0]?.value;

	let selected = active_actions?.[0]?.name || undefined; //selected is the active action's name

	$: deviceTargetTemp =
		typeof active_actions?.[0]?.value === 'number'
			? active_actions?.[0]?.value
			: deviceStatus?.['thermostat:0']?.target_C;
	//deviceTargetTemp is the target temperature of the Wall Display's thermostat
	//if active_actions[0].value is a number, that's mean we have a temperature number that is preset, for example this could happened if the wizard is in edit mode and we opened existing scene
	// otherwise I check if the deviceStatus has the target/current temperature of the TRV device, if not I use the trvMinValue as default value

	const updateAction = (actionName?, value?) => {
		//Using this function to update the active actions
		if (typeof actionName !== 'undefined' && typeof value !== 'undefined') {
			//If actionName and value are provided, then we update the active_actions with the provided values
			active_actions[0] = {
				name: actionName,
				value: value,
				is_data: false,
			};
			if (actionName === 'temp_enable' && value === false) {
				selected = 'temp_disable'; //this is because for cloud we have only temp_enable action with boolean value
			}
		} else {
			// If the active_actions is not empty, then we don't do anything
			//except if the active action is temp_enable, then we set the selected as temp_enable or temp_disable because from the cloud side there is only temp_enable action with boolean value available
			if (active_actions[0]?.name === 'temp_enable') {
				//If the active action is temp_enable, then we set the selected as temp_enable or temp_disable because from the cloud side there is only temp_enable action with boolean value available
				if (enabled) {
					selected = 'temp_enable';
				} else {
					selected = 'temp_disable';
				}
			}
		}

		sceneIsValid = true;

		dispatch('change_active', { new_active: active_actions });
	};

	const handle_temp_change = (e, _act) => {
		let { value, _ } = e.detail; //units here aren't needed because the Wall Display is always in Celsius. NB: Always use C in Scenes

		updateAction(_act?.id, value);
	};

	onMount(() => {
		if (!actions.map((a) => a.id)?.includes(selected) || selected === undefined) {
			//if the selected action is not in the list of actions then we need to set it to the first action
			enabled = true; //enable is the boolean value that is used to check if the thermostat is enabled or not from scene. Override the value from the active_actions this will be used on edit mode and arriving from different device
			selectAction('temp_enable');
		}

		updateAction(); //load the active actions
	});

	const selectAction = (id) => {
		//Using this function to select the action because initial actions must be with different id's but at the same time for the scene for thermostat state there is only  temp_enable with boolean value
		selected = id;
		switch (id) {
			case 'set_temp':
				updateAction('set_temp', deviceTargetTemp);
				break;
			case 'temp_enable':
				updateAction('temp_enable', true);
				break;
			case 'temp_disable':
				updateAction('temp_enable', false);
				break;
			default:
				break;
		}
	};
</script>

{#if actions.length > 0}
	<CardGrid sm={200} md={200} xl={200} noPaddingBottom class="mb-l">
		{#each actions as _val, _i}
			<div class="d-flex">
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					class="width-full"
					type="horizontal"
					variant="radio"
					selected={selected === _val.id}
					title={capFirstChar($format(_val.title))}
					icon={mappedIcons[_i]}
					on:click={() => selectAction(_val.id)}
				/>
			</div>
		{/each}
	</CardGrid>
	{#each actions as _act, _ind}
		{#if _act.id === 'set_temp' && selected === _act.id}
			<hr class="mb-m mt-m" />
			<TrvControlWithWheelV2
				value={deviceTargetTemp}
				min={5}
				max={35}
				units={'C'}
				on:change={(e) => handle_temp_change(e, _act)}
				step={0.5}
				btnStep={0.5}
			/>
		{/if}
	{/each}
{/if}
